import type { ReferenceRendererProps } from '@contember/react-client'
import clsx from 'clsx'
import type { ContentBlockReference } from '../../app/data/content/ContentFragment'
import styles from '../../app/styles/Logos.module.sass'
import { Container } from '../Container'
import { ContemberImage } from '../ContemberImage'

export const logos = ({ reference }: ReferenceRendererProps<ContentBlockReference>) => {
	return (
		<section className={clsx(styles.wrapper, 'section')}>
			<Container>
				{reference.primaryText && <h2 className={styles.headline}>{reference.primaryText}</h2>}
				<div className={styles.inner}>
					{reference.logoList?.items.map((item) => (
						<div className={styles.logo} key={item.id}>
							{item.logo && <ContemberImage image={item.logo} layout="responsive" />}
						</div>
					))}
				</div>
			</Container>
		</section>
	)
}
